module.exports = __webpack_public_path__ + "img/explainA.e37e42ef.png";